export default __webpack_public_path__ + "static/media/stock.e0bca591.webp";